import React from 'react';
import { getStoreCode } from '../../Store/Store.APP_ENV.js';

const prepaidStoreCodes = [
  'PBAU',
  'PBMY',
  'PBCA',
  'PBUS',
  'PBSG',
  'PBPH',
  'PBHK',
  'PBNZ',
  'PBTH',
  'PBUK',
  'PBAE',
  'PBID',
  'PBEU',
];

const muslimProStoreCodes = [
  'MPMY',
  'MPEU',
  'MPID',
  'MPUS',
  'MPUK',
];

const includedStores = [
  'PBMY',
  'PBSG',
  'PBHK'
];

export const isPrepaidStore = ({ code = '' }) => prepaidStoreCodes.includes(code);

export const isMuslimProStore = ({ code = '' }) => muslimProStoreCodes.includes(code);

export const willHideOnMuslimPro = WrapperComponent => ((props) => {
  const { store } = props;
  const { code = '' } = store;

  return (!code || isMuslimProStore(store)) ? null : <WrapperComponent {...props}/>;
});

export const includeProProgramme = () => {
  const code = getStoreCode();
  return includedStores.includes(code);
};



// WEBPACK FOOTER //
// ./src/Common/Store/Store.js